import './PreferencesInvalidEmail.scss'

import React from 'react';
import { Link } from 'react-router-dom';

const PreferencesInvalidEmail = () => (
  <div className="invalid-missing-email-section">
    <span className="invalid-missing-email-statement">
      <Link to="/profile/contact-information">Update your email address</Link>
      {` to make changes to your paperless preferences.`}
    </span>
  </div>
);

export default PreferencesInvalidEmail;